module.exports = __webpack_public_path__ + "img/dot-box.43b4050a.svg";